


































import { Component, Vue, Watch } from "vue-property-decorator";
import { ElForm } from "element-ui/types/form";
import { updatePassword, ReqUpdatePassword } from "../../api/admin";
import { param } from "../../utils/index";
import { ResCode } from "@/api/baseDefine";
import { logout } from "../../api/login";
import { UserModule } from "@/store/modules/user";
import { setTimeout } from "timers";
@Component
export default class Changepassword extends Vue {
  private admin = {
    password: "",
    newPassword: "",
    confirmPassword: ""
  };
  private validateEmpty(rule: any, value: string, callback: any) {
    if (value.length < 1) {
      callback(new Error(this.$t("validate.valueNotNull").toString()));
    } else {
      callback();
    }
  }

  private validatePass(rule: any, value: string, callback: any) {
    if (value.length < 8) {
      callback(
        new Error(this.$t("validate.passwordMustGreaterThan8").toString())
      );
    } else {
      callback();
    }
  }
  private validatePass2(rule: any, value: string, callback: any) {
    if (value !== this.admin.newPassword) {
      callback(new Error(this.$t("validate.twoPasswordNotEqual").toString()));
    } else {
      callback();
    }
  }

  private adminRules = {
    password: [
      { required: true, trigger: "blur", validator: this.validateEmpty }
    ],
    newPassword: [
      { required: true, trigger: "blur", validator: this.validatePass }
    ],
    confirmPassword: [
      { required: true, trigger: "blur", validator: this.validatePass2 }
    ]
  };
  private submitForm() {
    (this.$refs.admin as ElForm).validate((valid: boolean) => {
      if (valid) {
        this.updatePassword();
      } else {
        return false;
      }
    });
  }

  private async updatePassword() {
    let res = await updatePassword(<ReqUpdatePassword>{
      oldPassword: this.admin.password,
      newPassword: this.admin.newPassword,
      confirmPassword: this.admin.confirmPassword
    });
    console.log(res);
    if (res && res.code === ResCode.SUCCESS) {
      this.$router.push("/dashboard");
      this.$notify({
        title: this.$t("common.success").toString(),
        message: this.$t("notification.UpdatePasswordSuccess").toString(),
        type: "success"
      });
      // setTimeout(function() {
      //   UserModule.LogOut().then(() => {
      //     location.reload(); // 为了重新实例化vue-router对象 避免bug
      //   });
      // }, 1000);
    }
  }
  private resetForm() {
    (this.$refs.admin as ElForm).resetFields();
  }
  private getAdminUserInfo() {}
  private created() {
    this.getAdminUserInfo();
  }
}
